import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { AuditChecklist } from "@/components/audits/AuditChecklist";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";

export function AuditDetailPage() {
  const { auditId } = useParams({ strict: false });
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Audit"
        actions={
          <Button variant="outline" onClick={() => navigate({ to: "/dashboard/audits" })}>
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Audits
          </Button>
        }
      />
      <AuditChecklist auditId={auditId ?? ""} />
    </div>
  );
}
